import striptags from 'striptags'

export function blockSupportsHeadline(blockData: ImmutableMap) {
  return blockData.getIn(['columns', '0', 'type']) !== 'epages.divider'
}

export function isHeadlineEmpty(blockData: ImmutableMap) {
  return striptags(blockData.getIn(['headline', 'data', 'content'])) === ''
}

export function isHeadlineHidden(blockData: ImmutableMap) {
  // With the introduction of the headline element toggle functionality, the
  // default is to hide the headline. Before, it was always shown. Therefore,
  // default it to show the headline for existing shops if filled.
  const isHeadlineHidden =
    blockData.getIn(['headline', 'data', 'isHidden']) === undefined
      ? isHeadlineEmpty(blockData)
      : blockData.getIn(['headline', 'data', 'isHidden'])

  return isHeadlineHidden
}
